var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#61C478"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4995 37.5572L23.8729 32.9305C23.6236 32.6812 23.2854 32.5411 22.9329 32.5411C22.5803 32.5411 22.2422 32.6812 21.9929 32.9305C21.7436 33.1798 21.6035 33.5179 21.6035 33.8705C21.6035 34.0451 21.6379 34.2179 21.7047 34.3792C21.7715 34.5405 21.8694 34.6871 21.9929 34.8105L27.5662 40.3838C28.0862 40.9038 28.9262 40.9038 29.4462 40.3838L43.5529 26.2772C43.8022 26.0279 43.9422 25.6897 43.9422 25.3372C43.9422 24.9846 43.8022 24.6465 43.5529 24.3972C43.3036 24.1479 42.9654 24.0078 42.6129 24.0078C42.2603 24.0078 41.9222 24.1479 41.6729 24.3972L28.4995 37.5572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.56fac3e2ac14242f52f316736b6c4a7f.svg";
export { ForwardRef as ReactComponent };